import React, { useState, useEffect } from "react";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import { ToastContainer, Flip } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Loader from "../Shared_Components/Loader";
import "./style.css";
import { API_HOST } from "../api_utils";

function RegisterUser(props) {
  const { userDataFromStorage } = props;

  const [showPass, setShowPass] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [loginName, setLoginName] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [id_number, setId_number] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [gender, setGender] = useState("");
  const [state, setState] = useState("");
  const [streetName, setStreetName] = useState("");
  const [houseNo, setHouseNo] = useState("");
  const [postCode, setPostCode] = useState("");

  // loading and error states:
  const [loading, setLoading] = useState(false);

  let navigate = useNavigate();

  const shutPassHandler = () => {
    const passEl = document.getElementById("password");
    if (passEl.type === "text") {
      passEl.type = "password";
    }
    setShowPass(false);
  };

  const showPassHandler = () => {
    console.log("here");
    const passEl = document.getElementById("password");
    if (passEl.type === "password") {
      passEl.type = "text";
    }
    setShowPass(true);
  };

  const handleUserRegistration = async () => {
    if (
      firstName &&
      lastName &&
      loginName &&
      password &&
      confirmPassword &&
      houseNo &&
      streetName &&
      state &&
      postCode &&
      gender &&
      mobileNumber &&
      id_number
    ) {
      if (id_number.length === 10) {
        if (password === confirmPassword) {
          const regex = /^\d{10}$/;
          const testMobile = regex.test(mobileNumber);
          if (mobileNumber.length === 10 && testMobile === true) {
            setLoading(true);

            const registerUserPayload = {
              first_name: firstName,
              last_name: lastName,
              login_name: loginName,
              mobile_number: mobileNumber,
              id_number: id_number,
              password: password,
              gender: gender,
              state: state,
              street_name: streetName,
              post_code: postCode,
              house_number: houseNo,
            };

            try {
              const config = {
                headers: {
                  "Content-Type": "application/json",
                },
              };
              const { data } = await axios.post(
                `${API_HOST}/api/users/`,
                registerUserPayload,
                config
              );

              if (data) {
                if (data.message) {
                  setLoading(false);
                  toast.error(data.message);
                } else {
                  setLoading(false);
                  toast.success("User Registered Successfully");

                  // login user if registration success:
                  try {
                    const loginData = {
                      login_name: loginName,
                      password: password,
                    };
                    const config1 = {
                      headers: {
                        "Content-Type": "application/json",
                      },
                    };
                    const res = await axios.post(
                      `${API_HOST}/api/users/login`,
                      loginData,
                      config1
                    );

                    if (res) {
                      sessionStorage.setItem("user", JSON.stringify(res.data));
                      navigate("/home");
                      window.location.reload();
                    }
                  } catch (error) {
                    toast.error(error);
                  }
                }
              }
            } catch (error) {
              toast.error(error.response.data.message);
            }
          } else {
            setLoading(false);
            toast.error("Please Enter A Valid Mobile Number !!!");
          }
        } else {
          setLoading(false);
          toast.error("Password and Confirm Password didn't Match");
        }
      } else {
        setLoading(false);
        toast.error("Make Sure To Fill All Fields !!!");
      }
    } else {
      setLoading(false);
      toast.error("Make Sure To Fill All Fields !!!");
    }
  };

  return (
    <div
      className={
        userDataFromStorage.user_role === "admin"
          ? "xl:px-[10rem] lg:px-[6rem] md:px-[3.5rem] px-[2rem] py-[2rem] font-Roboto md:mt-[10%] lg:mt-[15%]  xl:mt-[9%] mt-[20%] bg-blue-50  overflow-hidden"
          : "xl:px-[10rem] lg:px-[6rem] md:px-[3.5rem] px-[2rem] py-[2rem] font-Roboto md:mt-[10%] lg:mt-[10%]  xl:mt-[5%] mt-[20%] bg-blue-50 overflow-hidden"
      }>
      {loading ? (
        <Loader />
      ) : (
        <div className="mb-8 shadow-gray-600 rounded-lg shadow-2xl xl:w-[50%] w-[80%] md:w-[80%] lg:w-[50%] mt-[4rem] p-[1rem] bg-white">
          <p className=" font-Roboto text-2xl font-[600] text-center mb-[2.5rem] text-[#a3391f]">
            User Registration Form
          </p>
          <div className="flex justify-start items-center space-x-4">
            <label
              htmlFor="firstName"
              className="text-lg text-[#57534e]  w-[10rem]">
              First Name
            </label>
            <input
              onChange={(e) => setFirstName(e.target.value)}
              type="text"
              id="firstName"
              className="border flex-1 rounded-lg p-[0.5rem] outline-none border-[#3b82f6] bg-sky-50 text-[#57534e] placeholder:text-[#57534e]"
              placeholder="Enter First Name"
              value={firstName}
            />
          </div>

          <div className="flex justify-start items-center space-x-4 mt-4">
            <label
              htmlFor="lastName"
              className="text-lg text-[#57534e]  w-[10rem]">
              Last Name
            </label>
            <input
              onChange={(e) => setLastName(e.target.value)}
              type="text"
              id="lastName"
              className="border flex-1 rounded-lg p-[0.5rem] outline-none border-[#3b82f6] bg-sky-50 text-[#57534e] placeholder:text-[#57534e]"
              placeholder="Enter Last Name"
              value={lastName}
            />
          </div>

          <div className="flex justify-start items-center space-x-4 mt-4">
            <label
              htmlFor="lastName"
              className="text-lg text-[#57534e]  w-[10rem]">
              Login Name
            </label>
            <input
              onChange={(e) => setLoginName(e.target.value)}
              type="text"
              id="loginName"
              className="border flex-1 rounded-lg p-[0.5rem] outline-none border-[#3b82f6] bg-sky-50 text-[#57534e] placeholder:text-[#57534e]"
              placeholder="Enter a Login Name"
              value={loginName}
            />
          </div>

          <div className="flex justify-start items-center space-x-4 mt-4">
            <label
              htmlFor="mobile"
              className="text-lg text-[#57534e]  w-[10rem]">
              Mobile Number
            </label>
            <input
              onChange={(e) => setMobileNumber(e.target.value)}
              type="tel"
              id="mobile"
              className="border flex-1 rounded-lg p-[0.5rem] outline-none border-[#3b82f6] bg-sky-50 text-[#57534e] placeholder:text-[#57534e]"
              placeholder="Enter Mobile Number"
              value={mobileNumber}
            />
          </div>

          <div className="flex justify-start items-center space-x-4 mt-4">
            <label
              htmlFor="id_number"
              className="text-lg text-[#57534e]  w-[10rem]">
              ID Number
            </label>
            <input
              onChange={(e) => setId_number(e.target.value)}
              type="number"
              id="id_number"
              className="border flex-1 rounded-lg p-[0.5rem] outline-none border-[#3b82f6] bg-sky-50 text-[#57534e] placeholder:text-[#57534e]"
              placeholder="Enter Mobile Number"
              value={id_number}
            />
          </div>

          <div className="flex justify-start items-center space-x-4 mt-4">
            <label
              htmlFor="password"
              className="text-lg text-[#57534e]  w-[10rem]">
              Password
            </label>
            <input
              onChange={(e) => setPassword(e.target.value)}
              type="password"
              id="password"
              className="border flex-1 rounded-lg p-[0.5rem] outline-none border-[#3b82f6] bg-sky-50 text-[#57534e] placeholder:text-[#57534e]"
              placeholder="Enter a Password"
            />
            <p
              className="text-stone-600 text-[1.8rem] hover:text-stone-400 "
              value={password}>
              {showPass === false ? (
                <AiFillEyeInvisible onClick={showPassHandler} />
              ) : (
                <AiFillEye onClick={shutPassHandler} />
              )}
            </p>
          </div>

          <div className="flex justify-start items-center space-x-4 mt-4">
            <label
              htmlFor="changePass"
              className="text-lg text-[#57534e]  w-[10rem]">
              Confirm Password
            </label>
            <input
              onChange={(e) => setConfirmPassword(e.target.value)}
              type="password"
              id="changePass"
              className="border flex-1 rounded-lg p-[0.5rem] outline-none border-[#3b82f6] bg-sky-50 text-[#57534e] placeholder:text-[#57534e]"
              placeholder="Confirm Password"
              value={confirmPassword}
            />
          </div>

          <div className="flex justify-start items-center space-x-4 mt-4">
            <label
              htmlFor="gender"
              className="text-lg text-[#57534e]  w-[10rem]">
              Gender
            </label>
            <select
              value={gender}
              onChange={(e) => setGender(e.target.value)}
              id="gender"
              className="border flex-1 rounded-lg p-[0.5rem] outline-none border-[#3b82f6] bg-sky-50 text-[#57534e] placeholder:text-[#57534e]">
              <option>Select A Gender</option>
              <option value="male">Male</option>
              <option value="female">Female</option>
              <option value="other">Other</option>
            </select>
          </div>

          <div className="flex justify-start items-center space-x-4 mt-4">
            <label
              htmlFor="state"
              className="text-lg text-[#57534e]  w-[10rem]">
              State
            </label>
            <input
              onChange={(e) => setState(e.target.value)}
              type="text"
              id="state"
              className="border flex-1 rounded-lg p-[0.5rem] outline-none border-[#3b82f6] bg-sky-50 text-[#57534e] placeholder:text-[#57534e]"
              placeholder="Enter a State"
              value={state}
            />
          </div>

          <div className="flex justify-start items-center space-x-4 mt-4">
            <label
              htmlFor="street"
              className="text-lg text-[#57534e]  w-[10rem]">
              Street Name
            </label>
            <input
              onChange={(e) => setStreetName(e.target.value)}
              type="text"
              id="street"
              className="border flex-1 rounded-lg p-[0.5rem] outline-none border-[#3b82f6] bg-sky-50 text-[#57534e] placeholder:text-[#57534e]"
              placeholder="Enter Street Address"
              value={streetName}
            />
          </div>

          <div className="flex justify-start items-center space-x-4 mt-4">
            <label
              htmlFor="houseNo"
              className="text-lg text-[#57534e]  w-[10rem]">
              House Number
            </label>
            <input
              value={houseNo}
              onChange={(e) => setHouseNo(e.target.value)}
              type="text"
              id="houseNo"
              className="border flex-1 rounded-lg p-[0.5rem] outline-none border-[#3b82f6] bg-sky-50 text-[#57534e] placeholder:text-[#57534e]"
              placeholder="Enter Street Address"
            />
          </div>

          <div className="flex justify-start items-center space-x-4 mt-4">
            <label
              htmlFor="postCode"
              className="text-lg text-[#57534e]  w-[10rem]">
              Post Code
            </label>
            <input
              value={postCode}
              onChange={(e) => setPostCode(e.target.value)}
              type="number"
              id="postCode"
              className="border flex-1 rounded-lg p-[0.5rem] outline-none border-[#3b82f6] bg-sky-50 text-[#57534e] placeholder:text-[#57534e]"
              placeholder="Enter Post Code"
            />
          </div>

          <div className="flex justify-center items-center mt-12 mb-4">
            <button
              onClick={handleUserRegistration}
              className="bg-[#a3391f] w-[100%] py-[0.7rem] rounded-lg text-[#fdba74] text-lg tracking-wider hover:bg-[#fdba74] hover:text-[#a3391f] transition duration-[0.6s] hover:shadow-xl">
              Register User
            </button>
          </div>
        </div>
      )}

      <ToastContainer
        newestOnTop={false}
        rtl={false}
        transition={Flip}
        position="top-right"
        autoClose={2000}
        theme="dark"
        hideProgressBar={false}
        closeOnClick={true}
        pauseOnHover={false}
        draggable={true}
        progress={undefined}
        className="text-center"
      />
    </div>
  );
}

export default RegisterUser;
